import React from 'react'
import { Route, Routes } from '@front/squirtle'

import ExportOrderList from './List'

const ExportOrderPage = props =>
  <Routes>
    <Route index element={<ExportOrderList />} />
  </Routes>


export default React.memo(ExportOrderPage)
